import * as React from "react"

const StepByStepList = ({ steps, className }) => {
  // Convert steps object to array
  const stepsArray = Object.entries(steps).map(([key, value]) => ({
    id: key,
    heading: value.heading,
    subHeading: value.subHeading,
  }))

  return (
    <section className={`${className ?? ""} step-by-step-list`} role="list">
      {stepsArray.map((step, index) => (
        <div key={step.id} className="step-by-step-list__item" role="listitem">
          <div className="step-by-step-list__number">{index + 1}</div>
          <p className="mb-0 h5 step-by-step-list__item-heading">
            {step.heading}
          </p>
          <p className="p--sm">{step.subHeading}</p>
        </div>
      ))}
    </section>
  )
}

export default StepByStepList
